import type { RowNode } from 'ag-grid-community';

import { checkIsPrepareChildField } from './checkIsPrepareChildField';

export const getPreparedFieldFromChildren = (node: RowNode | undefined) => {
  const preparedField = node?.allLeafChildren?.find((child) => checkIsPrepareChildField(child.id ?? ''));

  return preparedField;
};
